import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { HudsonFile } from '../types';
import { TableHeader } from './TableHeader';

interface PropTypes {
  hudsonFiles: HudsonFile[];
}

interface ConvertedHudsonFile {
  orderDate: Date;
  orderDateString: string;
  hdsNumber: string;
  address: string;
  city: string;
  town: string;
  village: string;
  borough: string;
  county: string;
  searchOrdered: string;
  section: string;
  block: string;
  lot: string;
}

const TableRow = ({ hudsonFile }: { hudsonFile: ConvertedHudsonFile }) => (
  <Table.Row>
    <Table.Cell collapsing>{hudsonFile.orderDateString}</Table.Cell>
    <Table.Cell collapsing>
      <b>{hudsonFile.hdsNumber}</b>
    </Table.Cell>
    <Table.Cell collapsing>{hudsonFile.address}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.city}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.town}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.village}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.borough}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.county}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.searchOrdered}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.section}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.block}</Table.Cell>
    <Table.Cell collapsing>{hudsonFile.lot}</Table.Cell>
  </Table.Row>
);

const HudsonFilesTab = (props: PropTypes) => {
  const [sortedHudsonFiles, setSortedHudsonFiles] = useState<ConvertedHudsonFile[]>([]);

  useEffect(() => {
    if (props.hudsonFiles) {
      setSortedHudsonFiles(
        props.hudsonFiles.map(h => ({
          ...h,
          orderDateString: h.orderDate,
          orderDate: parseDateFromString(h.orderDate),
        }))
      );
    }
  }, [props.hudsonFiles]);

  const parseDateFromString = (dateString: string) => {
    const dateParts = dateString.split('/');
    if (dateParts.length === 3) {
      const month = parseInt(dateParts[0]) - 1;
      const day = parseInt(dateParts[1]);
      const year = parseInt(dateParts[2]);
      return new Date(year, month, day);
    }
    return null;
  };

  return (
    <React.Fragment>
      {sortedHudsonFiles.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={[
              'Order Date',
              'HDS Number',
              'Address',
              'City',
              'Town',
              'Village',
              'Borough',
              'County',
              'Search Ordered',
              'Section',
              'Block',
              'Lot',
            ]}
            sortedData={sortedHudsonFiles}
            setSortedData={setSortedHudsonFiles}
          />
          <Table.Body>
            {sortedHudsonFiles.map(hf => (
              <TableRow hudsonFile={hf} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default HudsonFilesTab;
